import React from 'react';
import { MuiGrid, MuiTypography, MuiDialog } from '../../ui/MaterialUIComponents';
import { TextUtil } from '../../../utils'
import '../../ui/timeTableBlockScroll.css'
import theme from '../../../assests/theme';
class TimeTableBlock extends React.Component {


    render() {
        let list = this.props.blocket.availableTeachersList
        let i18n = this.props.i18n
        let subTeacherslist = this.props.blocket.teachers
        return (
            <MuiGrid>
                {(this.props.blocket.period.typeOfPeriod == 'break' || this.props.blocket.period.typeOfPeriod == 'lunch') ?
                    <MuiGrid elevation={3} id='scrollStyleForTT' style={{
                        zIndex: 100, position: 'relative', width: '97%', padding: 4, boxSizing: 'border-box', borderRadius: '3px', background: theme.palette.primary.lightest, height: this.props.cellHeight * this.props.blocket.totalBlocks - 1 + 'px',
                    }}  >

                        <MuiTypography style={this.props.setCellLunchTextStyleBasedOnLicense(this.props.noOfTTShowIndex, this.props.cardIndex)} color='primary'>
                            {this.props.showText(this.props.blocket.period.periodName, this.props.timeTableType, this.props.cardIndex)} </MuiTypography>
                    </MuiGrid> :
                    this.props.timeTableType == 'forClass' || this.props.timeTableType == 'forRooms' ?

                        <MuiGrid elevation={3} id='scrollStyleForTT' align='left' style={{ zIndex: 100, padding: 4, boxSizing: 'border-box', position: 'relative', width: '97%', borderRadius: '3px', background: this.props.blocket.style, height: this.props.cellHeight * this.props.blocket.totalBlocks - 1 + 'px', overflowY: 'auto' }}  >

                            <MuiTypography style={this.props.setCellTextStyleBasedOnLicense(this.props.noOfTTShowIndex, this.props.cardIndex)}> {this.props.blocket.subject != undefined &&
                                // this.props.blocket.subject} {this.props.blocket.label}
                                this.props.showText(this.props.blocket.subject + ' ', this.props.timeTableType, this.props.cardIndex)}
                                {this.props.showText(this.props.blocket.label, this.props.timeTableType, this.props.cardIndex)}
                                {this.props.blocket.className != undefined ?
                                    this.props.showText((" " + i18n.commonTexts.group+" " + this.props.blocket.className.toUpperCase()), this.props.timeTableType, this.props.cardIndex)
                                    : ''
                                }
                                {this.props.blocket.rooms != undefined && this.props.blocket.rooms.length > 0 ?
                                    this.props.showText(' #' + i18n.commonTexts.room+': ', this.props.timeTableType, this.props.cardIndex)
                                    : ''}
                                {

                                    this.props.blocket.rooms != undefined && this.props.blocket.rooms.map((room, index) =>
                                        <span style={{ wordBreak: 'break-all' }}>{this.props.showText(room, this.props.timeTableType, this.props.cardIndex)}{this.props.blocket.rooms.length > index + 1 ? ', ' : ""}
                                            {/* {((index + 1) % 7 == 0) ? <br /> : ''} */}
                                        </span>)
                                }
                                {
                                    subTeacherslist != undefined && subTeacherslist.map((teacher, index) =>
                                        <span >{" " + TextUtil.capitalize(this.props.showText(teacher.firstName + " " + teacher.lastName, this.props.timeTableType, this.props.cardIndex))}{subTeacherslist.length > index + 1 ? ',' : ""}
                                            {/* {((index + 1) % 7 == 0) ? <br /> : ''} */}
                                        </span>)
                                }
                            </MuiTypography>
                        </MuiGrid> :
                        this.props.blocket.availableTeachersList != undefined ?


                            //availale teacher individual tt
                            <MuiGrid elevation={3} id='scrollStyleForTT' style={{
                                zIndex: 100, position: 'relative', display: 'inline-block', textAlign: 'justify', width: '97%', cursor: 'pointer', borderRadius: '3px', background: this.props.blocket.style, height: this.props.cellHeight * this.props.blocket.totalBlocks - 1 + 'px', overflowY: 'auto'

                            }}  >

                                <MuiTypography style={{ fontSize: 12, padding: 4 }}> {
                                    list != undefined && list.map((aval, index) =>
                                        <span style={{ wordBreak: 'break-all' }}>{this.props.showText(aval.toUpperCase(), this.props.timeTableType, this.props.cardIndex)}{list.length > index + 1 ? ', ' : ""}
                                            {/* {((index + 1) % 7 == 0) ? <br /> : ''} */}
                                        </span>)
                                }</MuiTypography>

                            </MuiGrid>
                            :

                            //teacher individual tt
                            <MuiGrid elevation={3} align='left' id='scrollStyleForTT' style={{ zIndex: 100, padding: 4, boxSizing: 'border-box', position: 'relative', width: '97%', borderRadius: '3px', background: this.props.blocket.style, height: this.props.cellHeight * this.props.blocket.totalBlocks - 1 + 'px', overflowY: 'auto' }}  >
                                <MuiTypography style={this.props.setCellTextStyleBasedOnLicense(this.props.noOfTTShowIndex, this.props.cardIndex)}>
                                    {this.props.blocket.class1.subject.name != undefined &&
                                        this.props.showText(this.props.blocket.class1.subject.name, this.props.timeTableType, this.props.cardIndex) +
                                    this.props.showText(', '+i18n.commonTexts.group+" ", this.props.timeTableType, this.props.cardIndex) +
                                    this.props.showText((this.props.blocket.class1.className + "").toUpperCase(), this.props.timeTableType, this.props.cardIndex)
                                        + ', '}
                                    {this.props.showText(this.props.blocket.label, this.props.timeTableType, this.props.cardIndex)}

                                    {this.props.blocket.class1.subject.rooms != undefined && this.props.blocket.class1.subject.rooms.length > 0 ? ' #' + i18n.commonTexts.room+': ': ''}{

                                        this.props.blocket.class1.subject.rooms != undefined && this.props.blocket.class1.subject.rooms.map((room, index) =>
                                            <span style={{ wordBreak: 'break-all' }}>{this.props.showText(room, this.props.timeTableType, this.props.cardIndex)}{this.props.blocket.class1.subject.rooms.length > index + 1 ? ', ' : ""}
                                                {/* {((index + 1) % 7 == 0) ? <br /> : ''} */}
                                            </span>)
                                    }

                                </MuiTypography>

                            </MuiGrid>

                }
            </MuiGrid>


        )

    }
}

export default TimeTableBlock